import { XyoErc20Wrapper } from '@xyo-network/sdk-xyoworld-js'
import { createContext } from 'react'

export interface Currency {
  erc20?: XyoErc20Wrapper
  refresh?: () => void
}

export const CurrencyContext = createContext<Currency>({})
